<template>
  <!-- 案件信息填写表单（示例文书流程解析完成后弹出）：
       预填值全部来自 GetGenerationConfig 返回（props.config），用户可修改；
       「提交生成」由父组件创建文书记录，字段名与 GenerationJudgment 入参对齐 -->
  <div class="overlay" :class="{ show: open }" @click.self="$emit('close')">
    <div class="modal">
      <div class="modal-head">
        <div class="modal-title">案件信息填写表单</div>
        <button class="icon-btn" @click="$emit('close')">
          <svg class="icon sm"><use href="#jp-x" /></svg>
        </button>
      </div>
      <div class="modal-body">
        <a-form
          :model="form"
          :label-col="{ style: { width: '110px' } }"
          :wrapper-col="{ flex: 'auto' }"
        >
          <a-form-item label="案件类型">
            <a-select v-model:value="form.caseType" disabled>
              <a-select-option value="民事一审">民事一审</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="程序">
            <a-select v-model:value="form.applicableProcedure">
              <a-select-option value="普通程序">普通程序</a-select-option>
              <a-select-option value="小额诉讼程序"
                >小额诉讼程序</a-select-option
              >
              <a-select-option value="简易程序(非小额诉讼)"
                >简易程序(非小额诉讼)</a-select-option
              >
            </a-select>
          </a-form-item>
          <a-form-item label="案由">
            <a-input v-model:value="form.caseReason" />
          </a-form-item>
          <a-form-item label="是否有书记员">
            <a-radio-group v-model:value="form.mode">
              <a-radio value="with_clerk">有书记员</a-radio>
              <a-radio value="without_clerk">无书记员</a-radio>
            </a-radio-group>
          </a-form-item>
        </a-form>
      </div>
      <div class="modal-actions">
        <button class="btn" @click="$emit('close')">取消</button>
        <button class="btn primary" @click="$emit('submit', { ...form })">
          提交生成
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, watch } from "vue";

const props = defineProps({
  open: Boolean,
  // GetGenerationConfig（用上传返回的 documentId 调用）返回的文书生成配置，
  // 弹窗预填数据全部来源于此
  config: { type: Object, default: null },
});
defineEmits(["close", "submit"]);

// 预填：全部取自 GetGenerationConfig 返回（props.config），接口缺省的字段回退默认值
const form = reactive({
  caseType: "民事一审",
  applicableProcedure: "普通程序",
  caseReason: "",
  mode: "with_clerk",
});

// 每次打开重置回接口识别的预填值（取消/关闭后再进来不保留上次编辑）
watch(
  () => props.open,
  (open) => {
    if (open) {
      const cfg = props.config || {};
      Object.assign(form, {
        caseType: cfg.caseType || "民事一审",
        applicableProcedure: cfg.applicableProcedure || "普通程序",
        caseReason: cfg.caseReason || "",
        mode: cfg.mode || "with_clerk",
      });
    }
  },
);
</script>

<style scoped>
.overlay {
  --brand: #1768ff;
  --brand-hover: #0e59db;
  --line-2: #f0f3f7;
  position: fixed;
  inset: 0;
  background: rgba(18, 31, 53, 0.38);
  z-index: 100;
  display: none;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.overlay.show {
  display: flex;
}
.modal {
  width: min(680px, 92vw);
  max-height: 86vh;
  overflow: hidden;
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 24px 70px rgba(20, 36, 64, 0.25);
  border: 1px solid #e6ebf2;
  display: flex;
  flex-direction: column;
}
.modal-head {
  height: 58px;
  border-bottom: 1px solid var(--line-2);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 18px;
  flex: none;
}
.modal-title {
  font-weight: 800;
  font-size: 17px;
}
.modal-body {
  padding: 18px;
  overflow: auto;
}
.modal-actions {
  padding: 14px 18px;
  border-top: 1px solid var(--line-2);
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  flex: none;
}
.icon {
  width: 20px;
  height: 20px;
  stroke: currentColor;
  fill: none;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.icon.sm {
  width: 16px;
  height: 16px;
}
button {
  cursor: pointer;
}
.icon-btn {
  width: 32px;
  height: 32px;
  border: 0;
  background: transparent;
  border-radius: 8px;
  color: #60718a;
  display: grid;
  place-items: center;
}
.icon-btn:hover {
  background: #eef4ff;
  color: var(--brand);
}
.btn {
  height: 40px;
  border: 1px solid #dce4f0;
  border-radius: 10px;
  background: #fff;
  color: #31435f;
  padding: 0 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-weight: 650;
  font-size: 14px;
  transition: 0.16s;
}
.btn:hover {
  background: #f8fbff;
  border-color: #c9d6e8;
}
.btn.primary {
  background: var(--brand);
  border-color: var(--brand);
  color: #fff;
}
.btn.primary:hover {
  background: var(--brand-hover);
}
</style>
